import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../../network/consts";
import { ReportSummary } from "../@types";
import api from "../api";

export const SAMPLE_REPORT_KEY = "sampleReport";

const getSampleReportQueryKey = (
  hash?: string,
  sourceId?: number,
  relationshipId?: number
) => [SAMPLE_REPORT_KEY, hash, sourceId, relationshipId];

const useGetReportSummary = (
  hash?: string,
  sourceId?: number,
  relationshipId?: number
) => {
  const { data, isLoading, isFetched, refetch } = useQuery<
    AxiosResponse<ReportSummary>,
    unknown,
    ReportSummary
  >({
    queryKey: getSampleReportQueryKey(hash, sourceId, relationshipId),
    queryFn: () =>
      api.getSampleReportSummary(hash ?? "", sourceId ?? 0, relationshipId),
    select: ({ data: responseData }) => responseData,
    enabled: !!hash && !!sourceId,
    ...USEQUERY_DISABLE_REFETCH_OPTIONS
  });

  const isEmail = data?.file_type?.toLowerCase().startsWith("email");

  return { data, isLoading, isEmail, isFetched, refetch };
};

export default useGetReportSummary;
